import { render } from "./ScreenBase.vue?vue&type=template&id=4ab180e2"
import script from "./ScreenBase.vue?vue&type=script&lang=js"
export * from "./ScreenBase.vue?vue&type=script&lang=js"

import "./ScreenBase.vue?vue&type=style&index=0&id=4ab180e2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__